import { useSelector } from "react-redux";
import { Box, Container } from "@mui/material";

import { ContentGrid } from "../components";
import { selectActivePage, selectContents } from "../redux";
import { useEffect, useState } from "react";
import { Content } from "../types";
import { useTranslation } from "react-i18next";
import { searchContents } from "../utils/searchContents";

const keyPrefix = "pages.SearchPage";

export const SearchPage = () => {
  const [filterContentList, setFilterContentList] = useState<Content[]>([]);
  const { searchingContent } = useSelector(selectActivePage);
  const contents = useSelector(selectContents);
  const { t } = useTranslation("translation", { keyPrefix });

  useEffect(() => {
    setFilterContentList(searchContents(contents, searchingContent!));
    // eslint-disable-next-line
  }, [searchingContent]);

  return (
    <Container maxWidth="lg">
      <Box padding="32px 105px">
        <ContentGrid
          contentList={filterContentList}
          title={t("title").replace("{searchingContent}", searchingContent!)}
        />
      </Box>
    </Container>
  );
};
